/* eslint-disable no-shadow */
/* eslint-disable prefer-template */
import React, { useState, useEffect } from 'react';
import PropTypes, { any } from 'prop-types';

import CourtDeskSidePanel from '../../CourtSchedular/CourtDeskSidePanel';
import courtSchedularStyles from '../../CourtSchedular/courtSchedular.scss';
import Collapsible from '../../../../components/Form/Collapsible';
import SingleCheckbox from '../../../SearchPage/Filters/FilterComponents/CoreComponents/SingleCheckbox';
import Img from '../../../../components/Img';
import BackgroundImage from '../../../../components/BackgroundImage';
import config from '../../../../../config';
import styles from '../../drawEdit.scss';

const CheckInSidebar = (props) => {
    const { handleClosePanel, playerSelectedForCheckIn, handleSubmitCheckIn } = props;
    const imageBaseUrl = config.alwaysUseProxy ? '/api/v1/player/' : '/v1/player/';
    const [drawsDropDown, setDrawsDropDown] = useState(playerSelectedForCheckIn.draws);
    const [questionsData, setQuestionsData] = useState(playerSelectedForCheckIn.eventQuestionAnswers);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const handleClose = () => {
        setIsVisible(false);
    };
    const handleDropdownState = (group) => {
        setDrawsDropDown(prevState => {
            return prevState.map((dateGroup) => {
                if (dateGroup.date === group.date) {
                    return {
                        ...dateGroup,
                        isOpen: !dateGroup.isOpen,
                    };
                }
                return dateGroup;
            });
        });
    };

    const handleDrawsCheckInChange = (group, selection) => {
        setDrawsDropDown(prevState => {
            return prevState.map((dateGroup) => {
                if (dateGroup.date === group.date) {
                    return {
                        ...dateGroup,
                        draws: dateGroup.draws.map((draw) => {
                            if (draw.drawId === selection.drawId) {
                                return {
                                    ...draw,
                                    checkedIn: !draw.checkedIn,
                                };
                            }
                            return draw;
                        }),
                    };
                }
                return dateGroup;
            });
        });
    };

    const handleSave = () => {
        handleSubmitCheckIn(playerSelectedForCheckIn.memberId, drawsDropDown, questionsData);
    };

    const handleAnswerAcknowledge = (question) => {
        setQuestionsData(prevState => {
            return prevState.map((q) => {
                if (q.id === question.id) {
                    return {
                        ...q,
                        isAcknowledged: !q.isAcknowledged,
                    };
                }
                return q;
            });
        });
    };

    return (
        <CourtDeskSidePanel
            allowCloseOnClickOutside
            className="check-in-sidebar"
            closeSideBar={handleClose}
            isVisible={isVisible}
            onClose={handleClosePanel}
        >
            <div className={courtSchedularStyles.header} data-testid="draw-edit.check-in-sidebar.header">
                Check in {playerSelectedForCheckIn?.firstName} {playerSelectedForCheckIn?.lastName}
            </div>
            <div className={`${courtSchedularStyles.content} content-wrapper`}>
                {playerSelectedForCheckIn && (
                    <div>
                        <div className="player-profile">
                            <BackgroundImage
                                baseUrl={imageBaseUrl}
                                defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                images={playerSelectedForCheckIn.playerProfileImages}
                                imageType={'icon'}
                                parentStylesClass="player-profile-picture"
                            />
                        </div>
                        <div>
                            <div className="event-info pb24">
                                <div className="text-small text-xtra-dark fw500">EVENT INFO</div>
                                <div className="info-items d-flex jsb">
                                    <div className="info-item d-flex flex-col jcc aic">
                                        <div className="text-small text-xtra-dark fw500">EVENT AGE</div>
                                        <div className="info-item-number text-xtra-dark fw300" data-testid="draw-edit.check-in-sidebar.event-age">{playerSelectedForCheckIn.age}</div>
                                    </div>
                                    <div className="info-item d-flex flex-col jcc aic">
                                        <div className="text-small text-xtra-dark fw500">DRAWS IN</div>
                                        <div className="info-item-number text-xtra-dark fw300" data-testid="draw-edit.check-in-sidebar.draws-in">{playerSelectedForCheckIn.numDrawsTotal}</div>
                                    </div>
                                    <div className="info-item d-flex flex-col jcc aic">
                                        <div className="text-small text-xtra-dark fw500">CHECKED IN</div>
                                        <div className="info-item-number text-xtra-dark fw300" data-testid="draw-edit.check-in-sidebar.checked-in">{playerSelectedForCheckIn.numDrawsCheckedIn}</div>
                                    </div>
                                </div>
                                <p className="mb0 mt16 text-dark" data-testid="draw-edit.check-in-sidebar.birthdate">Date of birth: {playerSelectedForCheckIn.birthDateDisplay}</p>
                                <p className="mb0 text-dark">Age based on event start date</p>
                            </div>
                            <div className="contact-info mt20 pb24">
                                <div className="text-small text-xtra-dark fw500 mb12">CONTACT INFO</div>
                                {playerSelectedForCheckIn.email && (
                                    <div className="d-flex aic">
                                        <Img className="mr12" src="/img/v3/icons/icon-envelope.svg" />
                                        <p className="mb0 text-dark">{playerSelectedForCheckIn.email}</p>
                                    </div>
                                )}
                                {playerSelectedForCheckIn.phone && (
                                    <div className="d-flex aic mt8">
                                        <Img className="mr12" src="/img/v3/icons/icon-phone.svg" />
                                        <p className="mb0 text-dark">{playerSelectedForCheckIn.phone}
                                            <span className={`${styles.sms}`}>
                                                {playerSelectedForCheckIn.smsOptIn && <span className={`ml4 ${styles.on}`}>SMS ON</span>}
                                                {!playerSelectedForCheckIn.smsOptIn && <span className={`ml4 ${styles.off}`}>SMS OFF</span>}
                                            </span>
                                        </p>
                                    </div>
                                )}
                            </div>
                            {questionsData?.length > 0 && (
                                <div className="player-questions mt20 pb24">
                                    <div className="text-small text-xtra-dark fw500 mb12">QUESTIONS</div>
                                    {questionsData.map((question) => {
                                        return (
                                            <div className="bl pl8 mt16" key={question.id}>
                                                <div className="text-dark fw500">{question.text}</div>
                                                {question.answer && (
                                                    <>
                                                        <div className="mt8 mb8 text-dark fw300">{question.answer}</div>
                                                        {question.showAcknowledge && (
                                                            <SingleCheckbox
                                                                id={`${question.id}-ack-answer`}
                                                                label="Acknowledge"
                                                                isChecked={question.isAcknowledged}
                                                                onChange={() => handleAnswerAcknowledge(question)}
                                                                className="text-14 fw300"
                                                            />
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                            <div className="draw-check-in mt20 pb24">
                                <div className="text-small text-xtra-dark fw500 mb12">DRAW CHECK IN</div>
                                {
                                    drawsDropDown.map((group) => {
                                        return (
                                            <div className="mb12" key={group.showDate}>
                                                <Collapsible
                                                    isOpen={group.isOpen || false}
                                                    onClick={() => handleDropdownState(group)}
                                                    className="text-dark"
                                                    data-testid="check-in.sidebar.draw-group"
                                                >
                                                    {group.showDate}
                                                </Collapsible>
                                                {group.isOpen && (
                                                    <div className="ml24">
                                                        {group?.draws?.map((_draw) => {
                                                            return (
                                                                <SingleCheckbox
                                                                    id={_draw.drawId}
                                                                    label={_draw.drawName}
                                                                    isChecked={_draw.checkedIn}
                                                                    onChange={() => handleDrawsCheckInChange(group, _draw)}
                                                                    key={_draw.drawId}
                                                                />
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>

                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className={`${courtSchedularStyles.footer} d-flex`}>
                <button
                    className={'btn btn-default mr8 flex-1'}
                    type="button"
                    onClick={handleClose}
                    data-testid="draw-edit.check-in-sidebar.cancel-btn"
                >
                    Cancel
                </button>
                <button
                    className={`btn btn-primary flex-1`}
                    onClick={handleSave}
                    type="button"
                    data-testid="draw-edit.check-in-sidebar.save-btn"
                >
                    Save
                </button>
            </div>
        </CourtDeskSidePanel>
    );
};

CheckInSidebar.propTypes = {
    handleClosePanel: PropTypes.func.isRequired,
    handleSubmitCheckIn: PropTypes.func.isRequired,
    playerSelectedForCheckIn: PropTypes.objectOf(any).isRequired,
};

CheckInSidebar.defaultProps = {
};

export default CheckInSidebar;
